import { Navigate, Outlet, useSearchParams } from "react-router-dom";
import useAuthStore from "../store/authStore";
import { isSafeNext } from "../utils/authRedirect";

export default function PublicOnlyRoute({ role }) {
  const [searchParams] = useSearchParams();
  const nextUrl = searchParams.get("next");
  const seekerToken = useAuthStore((s) => s.seekerToken);
  const seekerUser = useAuthStore((s) => s.seekerUser);
  const employerToken = useAuthStore((s) => s.employerToken);
  const employerUser = useAuthStore((s) => s.employerUser);
  const isAuth = role === "employer" ? !!employerToken : !!seekerToken;
  const user = role === "employer" ? employerUser : seekerUser;
  const defaultRedirect =
    role === "employer" ? "/employers/dashboard" : "/app/dashboard";
  // Only honor `next` for seeker role to avoid cross-role redirect attacks
  // (e.g. an employer-login URL with ?next=/app/dashboard would otherwise
  // bounce an employer into the seeker app). Restrict targets to same-origin
  // relative paths.
  const redirect = isSafeNext(nextUrl, role) ? nextUrl : defaultRedirect;
  // If logged in but unverified — let them reach the login page so they can
  // see the right message, resend a verification email, or sign in with a
  // different account.
  if (isAuth && user && !user.is_verified) {
    return <Outlet />;
  }
  return isAuth ? <Navigate to={redirect} replace /> : <Outlet />;
}
